import { Classes, Overlay } from '@blueprintjs/core';
import React from 'react';
import Form from '../../components/common/Form';
//import http from "../../services/httpService";
//import toastr from "toastr";
//import { getCurrentUserId, getJwt} from "../../services/authService";

class ConnectBotToPageModal extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                email: props.email || ""
            },
            errors: {},
            spinnerActive: false
        };

        //toastr.options = {
        //    positionClass : "toast-bottom-full-width"
        //};
    }

    doSubmit = async () => {
        let data = this.props.disconnectPageModalData;
        await this.setState({spinnerActive: true})
        await this.props.toggleConnect({
            target: {
                id: data.id,
                attributes: {
                    value: {
                        nodeValue: data.value
                    },
                    name: {
                        nodevalue: data.name
                    }
                },
                title: data.title
            }
        });
        await this.setState({spinnerActive: false})
        this.props.handleClose();
    }

    //doSubmit = async (e) => {
    //    try {
    //        const user_id = getCurrentUserId();
    //        //alert(user_id);
    //        if(user_id)
    //        {
    //            //alert('api/user_activation/');
    //            //const result = await http.get('api/user-activation/' + user_id, {headers: {authorization: getJwt()}});
    //            await http.get('api/user-activation/' + user_id, {headers: {authorization: getJwt()}});
    //            //console.log("doSubmit user_activation result", result);
    //            //alert("result:", result);
    //            //if (result)
    //            //{
    //            //    toastr.success('result.status '+ result);
    //            //    //this.props.history.push('/logout');
    //            //}
    //            //else
    //            //{
    //            //    toastr.error('result.status '+ result);
    //            //    //this.props.history.push('/logout');
    //            //}
    //        }
    //
    //    }
    //    catch (ex) {
    //        //toastr.error(ex);
    //        if (ex.response && ex.response.status === 404)
    //        {
    //            toastr.error("404 (DATA NOT SENT)");
    //            //this.props.history.push('/logout');
    //        }
    //
    //        if (ex.response && ex.response.status === 401)
    //        {
    //            //let errors = { ...this.state.errors }
    //            //console.log(ex.response.data);
    //            toastr.error(ex.response.data.message);
    //            //window.location = "/";
    //            //this.props.history.push('/logout');
    //        }
    //        if (ex.response && ex.response.status === 400)
    //            toastr.error(ex);
    //    }
    //    window.location = "/logout";
    //};

    render() {
        let { selectedSource, sources } = this.props;
        // console.log('Props in ConnectBotToPageModal: ', this.props)
        let source = {};
        if (sources) {
            source = sources.filter(source =>
                source.id.toString() === selectedSource.toString())[0];
        }
        // let shared_feed_bool = false;
        // if (typeof (source) === "undefined") {
        //     source = feeds_shared.filter(source =>
        //         source.project_id.toString() === selectedSource.toString());
        //
        //     if (source.length) {
        //         shared_feed_bool = true;
        //     }
        // }
        //console.log("ConnectBotToPageModal source ", source);
        //
        //console.log("ConnectBotToPageModal sources, selectedSource ", sources, selectedSource);
        let source_name = source.name || "";
        return (

            // <div id="activationModal" className="modal" style={visible_modal ? {display: "block"} : {display: "none"}}>
            //     <div className="modal-content">
            //         <div className="onboarding-panel">
            //             <h2 className="m-m-b">Are you sure you want to disconnect from the workspace {source_name}?</h2>
            //
            //             <div className="submit-buttons row">
            //                 <div className="col-md-6">
            //                     <button disabled={false}
            //                             onClick={onClickAway}
            //                             name="cancel_team"
            //                             id="cancel_team"
            //                             type="button"
            //                             className='bg-darker-blue'>Cancel
            //                     </button>
            //                 </div>
            //                 <div className='col-md-6 text-right save-submit'>
            //                     <button disabled={false}
            //                             name="change_team"
            //                             id="delete_team_btn"
            //                             type="button"
            //                             onClick={toggleConnect}
            //                             className='btn-dark-blue edit-info active'>
            //                         Yes
            //                     </button>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            // </div>
        <Overlay
            // onClose={this.props.handleClose}
            className={Classes.OVERLAY_SCROLL_CONTAINER}
            // isOpen={this.state.overlayIsOpen}
            isOpen={this.props.showModal}
        >
            <div className="modal-field-payment"
                 style={{width: 500}}>
                <div className="add-payment-method-modal-container">

                    <div className='modal-title'>
                        <p className="modal-close-button" onClick={this.props.handleClose}><i
                            className="fas fa-times"></i></p>
                        <h2 className=''>Disconnect Page</h2>
                    </div>
                    <div className="modal-main">
                        <div className='margin-top-20 margin-bottom-20'>

                                <span
                                    className="">Are you sure you want to disconnect from the workspace <strong>{source_name}</strong>?</span>
                        </div>
                        <div className='justify-content-end flex-direction-row margin-bottom-20'>
                            <button disabled={false}
                                    onClick={this.props.handleClose}
                                    name="cancel_delete_tag"
                                    id="cancel_delete_tag"
                                    type="button"
                                    className="btn-white-border margin-right-10"
                            >
                                Cancel
                            </button>


                            {!this.state.spinnerActive ?
                                <button disabled={false}
                                        name="delete_tag"
                                        id="delete_tag"
                                        type="button"
                                        onClick={e=>this.doSubmit(e)}
                                        className="btn-danger">Yes</button>
                                :
                                <button disabled={true}
                                        name="change_team"
                                        id="delete_team_btn"
                                        type="button"
                                        className="btn-danger btn-spinner">Yes <i
                                    className='fa fa-spin fa-spinner'></i></button>
                            }
                        </div>
                    </div>
                </div>
            </div>

        </Overlay>
        )
    }
}

export default ConnectBotToPageModal;